import { demoDialogTitleSx, demoDialogTextSx } from './dialog-styles'

import React from 'react'
import { useTranslation } from 'react-i18next'
import Button from '@mui/material/Button'
import ButtonBase from '@mui/material/ButtonBase'
import Typography from '@mui/material/Typography'
import { Close } from '@vedmarket/ui-kit'

import { COLORS, ROUTES } from '../../../config/constants'
import { useAuthContext } from '../../../context/AuthContext'

const DemoCompletionDialog = ({ onClose }: DemoCompletionDialogProps) => {
  const { t } = useTranslation()
  const { user } = useAuthContext()
  const isRegistered = Boolean(user?.id)

  return (
    <div className='demo-step-dialog' data-demo-allowed='player'>
      <div className='demo-dialog' role='dialog' aria-modal='false' aria-labelledby='demo-completion-title'>
        <div className='demo-dialog__heading'>
          <Typography
            id='demo-completion-title'
            component='h2'
            sx={demoDialogTitleSx}
          >
            {t('calc__demoPlayer__introTitle')}
          </Typography>
          <ButtonBase
            onClick={onClose}
            aria-label={t('calc__demoPlayer__close')}
            sx={{
              padding: 0,
              color: COLORS.LIGHT_ACTION
            }}
          >
            <Close className='demo-dialog__close-icon' width={32} height={32} />
          </ButtonBase>
        </div>
        <div className='demo-dialog__copy'>
          <Typography
            component='span'
            className='demo-dialog__rocket'
            aria-hidden='true'
            sx={{
              fontSize: 64,
              lineHeight: 1,
              width: 64,
              '@media (min-width: 768px) and (max-width: 1199px)': {
                fontSize: 56,
                width: 56,
              },
              '@media (max-width: 767px)': {
                fontSize: 48,
                width: 48,
              },
              flexShrink: 0
            }}
          >🚀</Typography>
          <Typography
            sx={demoDialogTextSx}
          >
            {t(isRegistered ? 'calc__demoPlayer__completionRegisteredMessage' : 'calc__demoPlayer__completionMessage')}
          </Typography>
        </div>
        <Button
          variant='contained'
          fullWidth
          href={isRegistered ? `/${ROUTES.CABINET}/${ROUTES.CALCULATIONS}` : 'https://my.vedmarket.ru/register'}
          target='_blank'
          rel='noreferrer'
          data-demo-allowed='registration'
          sx={{
            '@media (max-width: 767px)': {
              padding: '8px',
            },
          }}
        >
          <Typography
            variant='button'
            sx={{
              lineHeight: '24px',
              letterSpacing: '1px',
              '@media (max-width: 767px)': {
                fontSize: 12,
              },
            }}
          >
            {t(isRegistered ? 'calc__text__demoFooterCabinetButton' : 'calc__text__demoRegisterButton')}
          </Typography>
        </Button>
      </div>
    </div>
  )
}

export default DemoCompletionDialog
